'use client';

import React, { useEffect, useRef, useState, useCallback } from 'react';
import ProgressSidebar from './ProgressSidebar';
import TopNav from './TopNav';
import Slide01Cover from './slides/Slide01Cover';
import Slide02BigIdea from './slides/Slide02BigIdea';
import Slide03Overview from './slides/Slide03Overview';
import Slide04Insight from './slides/Slide04Insight';
import Slide05Difference from './slides/Slide05Difference';
import Slide06Goals from './slides/Slide06Goals';
import Slide07JourneyOverview from './slides/Slide07JourneyOverview';
import Slide08Day1 from './slides/Slide08Day1';
import Slide12Day2 from './slides/Slide12Day2';
import Slide12bDay3 from './slides/Slide12bDay3';
import Slide12cDay4 from './slides/Slide12cDay4';
import Slide12dDay5 from './slides/Slide12dDay5';
import Slide12eDay6 from './slides/Slide12eDay6';
import Slide12fDay7 from './slides/Slide12fDay7';
import Slide12gDay8 from './slides/Slide12gDay8';
import Slide14Benefits from './slides/Slide14Benefits';
import Slide15Values from './slides/Slide15Values';
import Slide15bGrid from './slides/Slide15bGrid';
import Slide16LongTerm from './slides/Slide16LongTerm';
import Slide17SchoolValue from './slides/Slide17SchoolValue';
import Slide17bSchoolValue2 from './slides/Slide17bSchoolValue2';
import Slide17cSchoolValue3 from './slides/Slide17cSchoolValue3';
import Slide17dSchoolValue4 from './slides/Slide17dSchoolValue4';
import Slide17eCoopTable from './slides/Slide17eCoopTable';
import Slide18Media from './slides/Slide18Media';
import Slide20Strategic from './slides/Slide20Strategic';
import Slide21WinWin from './slides/Slide21WinWin';
import Slide22Direction from './slides/Slide22Direction';
import Slide23Ambassador from './slides/Slide23Ambassador';
import Slide24Role from './slides/Slide24Role';
import Slide25AmbassadorBenefits from './slides/Slide25AmbassadorBenefits';
import Slide25bFlexBenefits from './slides/Slide25bFlexBenefits';
import Slide27KeyMessage from './slides/Slide27KeyMessage';
import Slide28CTA from './slides/Slide28CTA';

export const SLIDES = [
  { id: 'slide-01', label: 'Cover', section: 'intro' },
  { id: 'slide-02', label: 'Big Idea', section: 'intro' },
  { id: 'slide-03', label: 'Tổng quan', section: 'intro' },
  { id: 'slide-04', label: 'Insight', section: 'intro' },
  { id: 'slide-05', label: 'Khác biệt', section: 'intro' },
  { id: 'slide-06', label: 'Mục tiêu', section: 'intro' },
  { id: 'slide-07', label: 'Hành trình', section: 'journey' },
  { id: 'slide-08', label: 'Ngày 1', section: 'journey' },
  { id: 'slide-12', label: 'Ngày 2', section: 'journey' },
  { id: 'slide-12b', label: 'Ngày 3', section: 'journey' },
  { id: 'slide-12c', label: 'Ngày 4', section: 'journey' },
  { id: 'slide-12d', label: 'Ngày 5', section: 'journey' },
  { id: 'slide-12e', label: 'Ngày 6', section: 'journey' },
  { id: 'slide-12f', label: 'Ngày 7', section: 'journey' },
  { id: 'slide-12g', label: 'Ngày 8', section: 'journey' },
  { id: 'slide-14', label: 'Quyền lợi', section: 'student' },
  { id: 'slide-15', label: 'Giá trị', section: 'student' },
  { id: 'slide-15b', label: 'Quyền lợi thêm', section: 'student' },
  { id: 'slide-16', label: 'Dài hạn', section: 'student' },
  { id: 'slide-17', label: 'Nhà trường 1', section: 'school' },
  { id: 'slide-17b', label: 'Nhà trường 2', section: 'school' },
  { id: 'slide-17c', label: 'Nhà trường 3', section: 'school' },
  { id: 'slide-17d', label: 'Nhà trường 4', section: 'school' },
  { id: 'slide-17e', label: 'Mô hình hợp tác', section: 'school' },
  { id: 'slide-18', label: 'Truyền thông', section: 'school' },
  { id: 'slide-20', label: 'Chiến lược', section: 'school' },
  { id: 'slide-21', label: 'Win-Win', section: 'partnership' },
  { id: 'slide-22', label: 'Định hướng', section: 'partnership' },
  { id: 'slide-23', label: 'Ambassador', section: 'ambassador' },
  { id: 'slide-24', label: 'Tiêu chí & Quyền lợi', section: 'ambassador' },
  { id: 'slide-25', label: 'Chính sách ưu đãi', section: 'ambassador' },
  { id: 'slide-25b', label: 'Trách nhiệm', section: 'ambassador' },
  { id: 'slide-27', label: 'Key Message', section: 'close' },
  { id: 'slide-28', label: 'Call to Action', section: 'close' },
];

export default function PresentationShell() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [navOpen, setNavOpen] = useState(false);
  const observerRefs = useRef<Map<string, IntersectionObserver>>(new Map());
  const slideRefs = useRef<Map<string, HTMLElement>>(new Map());

  const registerSlide = useCallback((id: string, el: HTMLElement | null) => {
    if (el) slideRefs.current.set(id, el);
  }, []);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    SLIDES.forEach((slide, index) => {
      const el = slideRefs.current.get(slide.id);
      if (!el) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveSlide(index);
            }
          });
        },
        { threshold: 0.4, rootMargin: '0px 0px -10% 0px' }
      );

      observer.observe(el);
      observers.push(observer);
      observerRefs.current.set(slide.id, observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  useEffect(() => {
    const fadeEls = document.querySelectorAll('.fade-in-up, .fade-in');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    fadeEls.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollToSlide = useCallback((index: number) => {
    const slide = SLIDES[index];
    const el = slideRefs.current.get(slide.id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setNavOpen(false);
  }, []);

  const scrollToId = useCallback((id: string) => {
    const el = slideRefs.current.get(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div className="relative bg-[#0f2318] min-h-screen">
      <TopNav
        slides={SLIDES}
        activeSlide={activeSlide}
        onScrollTo={scrollToSlide}
        navOpen={navOpen}
        setNavOpen={setNavOpen}
      />

      <ProgressSidebar
        slides={SLIDES}
        activeSlide={activeSlide}
        onScrollTo={scrollToSlide}
      />

      <main className="relative">
        <Slide01Cover id="slide-01" registerRef={registerSlide} />
        <Slide02BigIdea id="slide-02" registerRef={registerSlide} />
        <Slide03Overview id="slide-03" registerRef={registerSlide} />
        <Slide04Insight id="slide-04" registerRef={registerSlide} />
        <Slide05Difference id="slide-05" registerRef={registerSlide} />
        <Slide06Goals id="slide-06" registerRef={registerSlide} />
        <Slide07JourneyOverview id="slide-07" registerRef={registerSlide} />
        <Slide08Day1 id="slide-08" registerRef={registerSlide} />
        <Slide12Day2 id="slide-12" registerRef={registerSlide} />
        <Slide12bDay3 id="slide-12b" registerRef={registerSlide} />
        <Slide12cDay4 id="slide-12c" registerRef={registerSlide} />
        <Slide12dDay5 id="slide-12d" registerRef={registerSlide} />
        <Slide12eDay6 id="slide-12e" registerRef={registerSlide} />
        <Slide12fDay7 id="slide-12f" registerRef={registerSlide} />
        <Slide12gDay8 id="slide-12g" registerRef={registerSlide} />
        <Slide14Benefits id="slide-14" registerRef={registerSlide} />
        <Slide15Values id="slide-15" registerRef={registerSlide} />
        <Slide15bGrid id="slide-15b" registerRef={registerSlide} />
        <Slide16LongTerm id="slide-16" registerRef={registerSlide} />
        <Slide17SchoolValue id="slide-17" registerRef={registerSlide} />
        <Slide17bSchoolValue2 id="slide-17b" registerRef={registerSlide} />
        <Slide17cSchoolValue3 id="slide-17c" registerRef={registerSlide} />
        <Slide17dSchoolValue4 id="slide-17d" registerRef={registerSlide} />
        <Slide17eCoopTable id="slide-17e" registerRef={registerSlide} />
        <Slide18Media id="slide-18" registerRef={registerSlide} />
        <Slide20Strategic id="slide-20" registerRef={registerSlide} />
        <Slide21WinWin id="slide-21" registerRef={registerSlide} onScrollToId={scrollToId} />
        <Slide22Direction id="slide-22" registerRef={registerSlide} />
        <Slide23Ambassador id="slide-23" registerRef={registerSlide} onScrollToId={scrollToId} />
        <Slide24Role id="slide-24" registerRef={registerSlide} onScrollToId={scrollToId} />
        <Slide25AmbassadorBenefits id="slide-25" registerRef={registerSlide} onScrollToId={scrollToId} />
        <Slide25bFlexBenefits id="slide-25b" registerRef={registerSlide} />
        <Slide27KeyMessage id="slide-27" registerRef={registerSlide} />
        <Slide28CTA id="slide-28" registerRef={registerSlide} />
      </main>
    </div>
  );
}